'use client';

import React from 'react';
import styled from '@emotion/styled';
import { colors, breakpoints, size } from "@argo/principles";
import { Link } from "@argo/ui-elements";
import { navbp } from '../../header/utils/constants';
import { GLOBALNAV_KBB_BASE_URL } from '../../mykbb/utils/constants';
const LinksBase = styled('div')`
  color: ${colors.primary.white};
  margin: 0 ${size.md}px ${size.md}px ${size.md}px;
  column-count: 2;
  column-width: 120px;
  column-gap: ${size.sm}px;

  @media (min-width: ${breakpoints.md}px) {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: center;
    column-count: 1;
  }

  @media (min-width: ${navbp.ipadLandscape}) {
    justify-content: center;
  }

  > a {
    display: inline-block;
    width: 100%;
    padding: 12px 0;
    margin: 0 0 ${size.xs}px 0;

    @media (min-width: ${breakpoints.md}px) {
      width: auto;
    }
  }

`;
const SpanDivider = styled.span`
  display: none;

  @media (min-width: ${breakpoints.md}px) {
    display: block;
    margin: ${size.xs}px ${size.sm}px ${size.sm}px;
    padding-top: ${size.micro}px;
  }
`;
function getWindowFunctionByPath(path) {
  if (!path) return undefined;
  return path.split('.').reduce((obj, key) => obj && obj[key] ? obj[key] : undefined, window);
}
function handleFooterLinkClick(e, link, triggerAnalytics) {
  if (triggerAnalytics) {
    const analyticsFn = triggerAnalytics({
      googleTag: link?.googleTag,
      pixallTag: link?.pixallTag
    });
    if (typeof analyticsFn === 'function') {
      analyticsFn();
    }
  }
  if (typeof window !== 'undefined' && link?.javascriptFunc) {
    const func = getWindowFunctionByPath(link?.javascriptFunc);
    if (typeof func === 'function') {
      e.preventDefault();
      func();
    }
  }
}
const Links = function ({
  links,
  triggerAnalytics
}) {
  return React.createElement(LinksBase, null, links && links.map((link, i) => [React.createElement(Link, {
    key: i,
    "data-automation": `${link.omnitureTag}footer`,
    "data-partner": link.partnerLink,
    "data-tag-id": `footerLinks${i}`,
    onClick: e => handleFooterLinkClick(e, link, triggerAnalytics),
    rel: link?.rel || null,
    target: link.target,
    href: `${GLOBALNAV_KBB_BASE_URL}${link.url}`,
    dangerouslySetInnerHTML: {
      __html: link.name
    },
    type: 'unstyled'
  }), i !== links.length - 1 && React.createElement(SpanDivider, {
    key: `a${i}`
  }, "|")]));
};
Links.displayName = 'Links';
export default Links;